import { supabase } from "../../config/supabase";

// Update a course
const updateCourse = async (courseId,interests = [], challenges = [],title = '',description = '' ) => {
    try {
        const updatedCourse = {
            interests:interests.map(val => val.toLowerCase()),
            challenges:challenges.map(val => val.toLowerCase()),
            title:title.toLowerCase(),
            description:description.toLowerCase()
        }
        const { error } = await supabase.from('courses').update(updatedCourse).eq('course_id', courseId);
        if (error) throw new Error(error);
        return { error: null };
    } catch (err) {
        console.log('an error in updating courses:',err);
        return { error: err };
    }
};

export { updateCourse };